import {
  CorporateFormFields,
  ReportingOption,
  CorpInvoicingMethod,
  CorpInvoicingPeriod,
} from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { BrandOptionsEnum } from 'src/components/enterprise/features/Corporate/components/Form/BrandOptions/BrandOptions';
import { InvoicingSubtotalMethod } from 'src/types/Corp';

export const generateRandomizedFirmName = (): string => {
  const today = new Date();
  const dateString = today.toISOString().split('T')[0].replace(/-/g, '');
  const randomNumber = Math.floor(Math.random() * 100)
    .toString()
    .padStart(2, '0');
  return `CorpCreate${dateString}${randomNumber}`;
};

export const isFieldEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  if (typeof value === 'object' && Object.keys(value).length === 0) {
    return true;
  }
  if (Array.isArray(value) && value.length === 0) {
    return true;
  }
  return false;
};

export const getAutofilledFormValues = (): Partial<CorporateFormFields> => {
  const today = new Date();

  return {
    name: generateRandomizedFirmName(),
    markets: '',
    invoiceTimeZone: 'US/Central',
    phoneNumber: '',
    salesPersonCode: 'SALES003',
    expenseCodeAliasSingular: 'expense code',
    brand: BrandOptionsEnum.GRUBHUB,
    effectiveDate: today,
    firmTransactionFee: '3.00',
    intacctTermName: 'Net 15',
    reporting: ReportingOption.NONE_REPORTING_OPTION,
    invoiceContactFirstName: 'John',
    invoiceContactLastName: 'Doe',
    invoiceContactEmail: 'johndoe@grubhub.com',
    invoiceContactPhoneNumber: '(555) 555-5555',
    invoiceContactCity: 'New York',
    invoiceContactAddress1: '123 Main Street',
    invoiceContactZip: '10001',
    invoiceContactState: 'NY',
    invoicingMethod: CorpInvoicingMethod.SINGLE_OPTION,
    invoicingSubtotalMethod:
      InvoicingSubtotalMethod.MEAL_TYPE_SUBTOTAL_INVOICE_METHOD,
    invoiceRrule: CorpInvoicingPeriod.WEEKLY,
    cateringServiceFee: '1.00',
    maxCreditCardCharge: null,
    invoicePaymentMethod: null,
    defaultMerchantRestrictions: {},
    defaultItemRestrictions: {},
  };
};
